






























import {Vue, Component, Prop} from 'vue-property-decorator';
import {IEmployment} from "@/dto/payroll/IEmployment";
import {CreateVacationPayload, VacationBalance} from "@/dto/payroll/VacationDTO";
import PortalDate from "@/components/common/PortalDate.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {ifValid, processError} from "@/utils/ComponentUtils";
import SelectOption from "@/components/common/SelectOption";
import PortalSelect from "@/components/common/PortalSelect.vue";
import VacationService from "@/services/payroll/VacationService";

@Component({
	components: {PortalSelect, PortalCheckbox, PortalDate}
})
export default class VacationCreationModal extends Vue {

	@Prop({default: null})
	private employment!: IEmployment | null

	@Prop({default: null})
	private employments!: Array<IEmployment> | null

	@Prop()
	private callback!: () => void

	private balance: VacationBalance | null = null

	get employmentOptions(): Array<SelectOption> {
		return this.employments!.map(it => SelectOption.builder().title(it.details.name).value(it.id).build())
	}

	private req = new CreateVacationPayload(
		{
			employmentId: this.employment ? this.employment.id! : null,
			startTime: "10:00",
			endTime: "18:00"
		}
	)

	private loadAvailableBalance() {
		if (this.req.employmentId) {
			Application.startLoading()
			VacationService.getVacationBalance(this.req.employmentId).then(
				res => {
					this.balance = res.data;
					Application.stopLoading()
				},
				err => processError(err, this)
			)
		}
	}

	public created() {
		this.loadAvailableBalance()
	}

	private create() {
		ifValid(this, () => {
			Application.startLoading();
			VacationService.createVacationRecord(this.req).then(
				() => {
					this.$modal.hideAll();
					Application.stopLoading()
					this.callback()
				},
				err => processError(err, this)
			)
		})
	}

}
